<template>
  <div class="form">
      <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.form{
    padding: 20px;
    height: calc(100% - 80px);
    box-sizing: border-box;
    overflow-y: auto;
    .input{
      display: block;
      width: 80%;
    }
}
.btns{
  padding: 20px 20px 0 20px;
  text-align: right;
  .ant-btn{
    display: inline-block;
    margin-left: 20px;
  }
}
</style>